import { PATH } from '@/app/constants/path';
import { useAnalytics } from '@/app/utils/useAnalytics';
import LoginIcon from '@/modules/LandingHeaderV2/assets/LoginIcon.svg';
import SurgeryOnboarding from '@/modules/LandingHeaderV2/assets/SurgeryOnboarding.svg';
import { pushGtmEvent } from '@/utils/gtm';
import cx from 'classnames';
import Link from 'next/link';

import styles from './MobileUserNavLinks.module.scss';

interface MobileUserNavLinksProps {
  isSmallScreen?: boolean;
  onSignInClick?: () => void;
  signInUrl?: string;
  isUserLoggedIn?: boolean;
  registerUrl?: string;
}

export const MobileUserNavLinks = ({
  isSmallScreen,
  onSignInClick,
  signInUrl,
  registerUrl,
  isUserLoggedIn,
}: MobileUserNavLinksProps) => {
  const track = useAnalytics();

  const userNavActions = isUserLoggedIn
    ? {
        label: 'Sign out',
        to: PATH.LOGOUT,
      }
    : {
        label: 'Sign in',
        to: signInUrl ?? '',
      };

  return isSmallScreen ? (
    <>
      <Link
        href={userNavActions.to}
        onClick={
          !isUserLoggedIn
            ? () => {
                pushGtmEvent({
                  event: 'sign_in_click',
                  element: 'Sign In',
                  event_label: 'nav_sign_in',
                });
                onSignInClick?.();
              }
            : undefined
        }
        className={cx(styles.mobileUserActionButton, isUserLoggedIn && styles.lastChild)}
        data-testid="sign-in-button"
      >
        <div className={styles.actionText}>
          {userNavActions.label} <LoginIcon height={44} width={44} viewBox="0 0 29 25" />
        </div>
      </Link>
      {!isUserLoggedIn && (
        <Link
          href={registerUrl ?? ''}
          className={styles.mobileRegisterButton}
          data-testid="register-button"
          onClick={() => {
            track('Click nav Register', {});
            pushGtmEvent({
              event: 'register_click',
              element: 'Register',
              event_label: 'nav_register',
            });
          }}
        >
          <div className={styles.registerText}>
            Join us <SurgeryOnboarding height={44} width={44} viewBox="0 0 31 30" />
          </div>
        </Link>
      )}
    </>
  ) : null;
};
